import '@styles/pages/homepage.scss';
import { initCarousel } from '@molecules/carousel';
import { initOfferCard } from '@molecules/components/offer-card';

import { flickitySliderBySelector } from '@molecules/flickity-continuous-slider';
import { initSelectionBusHandler } from '@molecules/selection-bus-handler';
import { selectionSliderManager } from '@molecules/selection-slider-manager';
import { stickyCta } from '@organisms/sticky-cta';
import 'lite-youtube-embed';

stickyCta('.home-sticky', '.home-hero__ctas', 'home-sticky');
flickitySliderBySelector('.home-components-customers');
initCarousel();
initOfferCard();
initSelectionBusHandler();
selectionSliderManager();
